<template>
  <w-icon-wrapper
    icon-name='work-text-block-icon'
    width="20.55"
    height="24"
    viewBox="0 0 20.55 24"
  >
    <g
      id="Gruppe_25855"
      data-name="Gruppe 25855"
      transform="translate(2614 -349.39)"
    >
      <g
        id="Textbaustein"
        transform="translate(-2682 347.74)"
      >
        <path
          id="Vereinigungsmenge_4"
          data-name="Vereinigungsmenge 4"
          d="M2684.87-323.74a2.876,2.876,0,0,1-2.87-2.87v-18.26a2.877,2.877,0,0,1,2.87-2.87h14.81a2.877,2.877,0,0,1,2.87,2.87v18.26a2.876,2.876,0,0,1-2.87,2.87Zm-1.07-21.13v18.26a1.071,1.071,0,0,0,1.07,1.07h14.81a1.071,1.071,0,0,0,1.07-1.07v-18.26a1.071,1.071,0,0,0-1.07-1.07h-14.81A1.071,1.071,0,0,0,2683.8-344.87Zm1.9,17.681a.7.7,0,0,1-.7-.7.7.7,0,0,1,.7-.7h12.98a.7.7,0,0,1,.7.7.7.7,0,0,1-.7.7Zm0-3.161a.7.7,0,0,1-.7-.7.7.7,0,0,1,.7-.7h12.98a.7.7,0,0,1,.7.7.7.7,0,0,1-.7.7Zm8.75-3.51a.7.7,0,0,1-.7-.7.7.7,0,0,1,.7-.7h4.23a.7.7,0,0,1,.7.7.7.7,0,0,1-.7.7Zm0-2.869a.7.7,0,0,1-.7-.7.7.7,0,0,1,.7-.7h4.23a.7.7,0,0,1,.7.7.7.7,0,0,1-.7.7Zm0-2.88a.7.7,0,0,1-.7-.7.7.7,0,0,1,.7-.7h4.23a.7.7,0,0,1,.7.7.7.7,0,0,1-.7.7Z"
          transform="translate(-2614 349.39)"
          fill="currentColor"
        />
        <path
          id="Pfad_55752"
          data-name="Pfad 55752"
          d="M71.7,10.78a.7.7,0,0,0,.7-.7V9.66h1.53v4.81h-.22a.7.7,0,0,0,0,1.4h1.84a.7.7,0,0,0,0-1.4h-.22V9.66h1.53v.42a.7.7,0,1,0,1.4,0V8.26H71v1.82a.7.7,0,0,0,.7.7Z"
          fill="currentColor"
        />
      </g>
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkTextBlockIcon' };
</script>